/* VendPeptides theme — cart drawer, quantity-tier selection, COA lookup */
(function () {
  'use strict';
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('[data-burger]'),
      nav = document.querySelector('[data-nav]');
  if (burger && nav) burger.addEventListener('click', function () {
    nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', nav.classList.contains('is-open'));
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  function openDrawer()  { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); refresh(); }
    if (e.target.closest('[data-cart-close]') || e.target.hasAttribute('data-drawer-bg')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function render(cart) {
    var body = document.querySelector('[data-cart-body]'),
        sub  = document.querySelector('[data-cart-sub]'),
        cnt  = document.querySelectorAll('[data-cart-count]'),
        foot = document.querySelector('[data-cart-foot]');
    cnt.forEach(function (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty">Your cart is empty</div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img class="ci-img" src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">'
                        : '<div class="ci-img"></div>';
      var opt = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      return '<div class="ci">' + img +
        '<div><a class="ci-t" href="' + i.url + '">' + i.product_title + '</a>' +
        (opt ? '<div class="ci-v">' + opt + ' &middot; qty ' + i.quantity + '</div>'
             : '<div class="ci-v">qty ' + i.quantity + '</div>') +
        '<button class="ci-rm" data-remove="' + i.key + '">Remove</button></div>' +
        '<div class="ci-p">' + money(i.final_line_price) + '</div></div>';
    }).join('');
    if (sub) sub.textContent = money(cart.total_price);
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (!rm) return;
    e.preventDefault();
    rm.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: rm.getAttribute('data-remove'), quantity: 0 })
    }).then(function (r) { return r.json(); }).then(render).catch(function () { rm.disabled = false; });
  });

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { openDrawer(); refresh(); })
      .catch(function () {})
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- quantity-tier selector ---------- */
  document.querySelectorAll('[data-tiers]').forEach(function (root) {
    var priceEl = document.querySelector('[data-price]'),
        perEl   = document.querySelector('[data-permg]'),
        btn     = document.querySelector('[data-atc-btn]');
    function sync() {
      var on = root.querySelector('input:checked');
      root.querySelectorAll('.tier').forEach(function (t) {
        t.classList.toggle('is-on', t.contains(on));
      });
      if (!on) return;
      if (priceEl) priceEl.textContent = on.getAttribute('data-price');
      if (perEl) {
        var per = on.getAttribute('data-permg');
        perEl.textContent = per || '';
        perEl.hidden = !per;
      }
      if (btn) {
        var avail = on.getAttribute('data-available') === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? 'Add to cart' : 'Out of stock';
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', on.value);
      window.history.replaceState({}, '', url);
    }
    root.addEventListener('change', sync);
    sync();
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('[data-main-img]');
      if (!main) return;
      var img = main.querySelector('img');
      if (!img) { img = document.createElement('img'); main.innerHTML = ''; main.appendChild(img); }
      img.src = b.getAttribute('data-thumb');
      main.classList.remove('is-empty');
      document.querySelectorAll('[data-thumb]').forEach(function (o) { o.classList.remove('is-on'); });
      b.classList.add('is-on');
    });
  });

  /* ---------- COA batch lookup ---------- */
  document.querySelectorAll('[data-coa]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input'),
          out   = form.parentNode.querySelector('[data-coa-res]'),
          v     = (input.value || '').trim().toUpperCase();
      if (!out) return;
      if (!v) { out.className = 'coa-res no'; out.textContent = 'Enter a batch number.'; return; }
      if (!/^VP-[A-Z0-9]{2,4}-\d{6}$/.test(v)) {
        out.className = 'coa-res no';
        out.textContent = 'Not a valid batch format. Expected VP-XX-YYMMDD, e.g. VP-TZ-260814.';
        return;
      }
      out.className = 'coa-res ok';
      out.textContent = 'Batch ' + v + ' — certificate request received. We will email the chromatogram and MS report.';
    });
  });

  refresh();
})();

/* ---------- article table of contents (articles with >= 4 H2) ---------- */
(function () {
  var art = document.querySelector('[data-article]'), toc = document.querySelector('[data-toc]');
  if (!art || !toc) return;
  var hs = Array.prototype.slice.call(art.querselectorAll ? [] : art.querySelectorAll('h2'));
  if (hs.length < 4) return;
  var ol = toc.querySelector('ol'), used = {};
  hs.forEach(function (h) {
    var base = (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
    var id = base, n = 2; while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
    used[id] = 1; if (!h.id) h.id = id;
    var li = document.createElement('li'), a = document.createElement('a');
    a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
  });
  toc.hidden = false;
})();
